import { create } from 'zustand';

export interface TeamMember {
  id: string;
  name: string;
  userId?: string; // Optional: same user can be in multiple teams
}

export interface Team {
  id: string;
  name: string;
  members: TeamMember[];
  color: string;
}

interface TeamState {
  team1: Team | null;
  team2: Team | null;
  setTeam1: (team: Team) => void;
  setTeam2: (team: Team) => void;
  addMemberToTeam1: (member: TeamMember) => void;
  addMemberToTeam2: (member: TeamMember) => void;
  removeMemberFromTeam1: (memberId: string) => void;
  removeMemberFromTeam2: (memberId: string) => void;
  clearTeams: () => void;
}

export const useTeamStore = create<TeamState>((set) => ({
  team1: null,
  team2: null,
  setTeam1: (team) => set({ team1: team }),
  setTeam2: (team) => set({ team2: team }),
  addMemberToTeam1: (member) => set((state) => ({
    team1: state.team1
      ? { ...state.team1, members: [...state.team1.members, member] }
      : { id: 'team1', name: 'الفريق الأول', members: [member], color: '#E53935' }
  })),
  addMemberToTeam2: (member) => set((state) => ({
    team2: state.team2
      ? { ...state.team2, members: [...state.team2.members, member] }
      : { id: 'team2', name: 'الفريق الثاني', members: [member], color: '#1B5E20' }
  })),
  removeMemberFromTeam1: (memberId) => set((state) => ({
    team1: state.team1
      ? { ...state.team1, members: state.team1.members.filter(m => m.id !== memberId) }
      : null
  })),
  removeMemberFromTeam2: (memberId) => set((state) => ({
    team2: state.team2
      ? { ...state.team2, members: state.team2.members.filter(m => m.id !== memberId) }
      : null
  })),
  clearTeams: () => set({ team1: null, team2: null }),
}));
